import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { Pv2ButtonMenuItemComponent } from './button-menu-item.component';
import { Pv2ContentMenuItem } from '../../../models';

@Component({
  selector: 'pv2-button-menu',
  templateUrl: 'button-menu.component.html',
  styleUrl: 'button-grid-menu.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, Pv2ButtonMenuItemComponent],
})
export class Pv2ButtonMenuComponent {
  public readonly items = input.required<Pv2ContentMenuItem[]>();
  public readonly eventSource = input.required<string>();
  public readonly scrollOnMobile = input(true, { transform: booleanAttribute });
  public readonly largeOnMobile = input(false, { transform: booleanAttribute });
  public nameOnBottom = input(false, { transform: booleanAttribute });
  public showTitleOnTop = input(true, { transform: booleanAttribute });
  public showTagLine = input(true, { transform: booleanAttribute });

  protected menuItems = computed(() => {
    const menuItems: Pv2ContentMenuItem[] = [];
    const items = this.items();
    if (items) {
      for (const item of items) {
        menuItems.push(item);
      }
    }
    return menuItems;
  });

  protected gridKlasses = computed(() => {
    const gridKlasses: string[] = [];
    if (this.scrollOnMobile()) {
      gridKlasses.push('scroll-on-mobile');
    }

    if (this.largeOnMobile()) {
      gridKlasses.push('large-on-mobile');
    }
    return gridKlasses;
  });
}
